export default "__VITE_ASSET__s3jERT49__"